// JWT access token issued by the login/socialLogin/renewToken mutations
// (session → JWT migration, PLT-3412). Stored in a cookie on the admin
// origin; attached as an Authorization Bearer header on GraphQL requests.
export const ACCESS_TOKEN_COOKIE = "ns.a";

const TOKEN_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
const RENEW_THRESHOLD_SECONDS = 7 * 24 * 60 * 60;

export const getAccessToken = () => {
  if (typeof document === "undefined") return;
  const parts = ("; " + document.cookie).split(`; ${ACCESS_TOKEN_COOKIE}=`);
  if (parts.length < 2) return;
  return parts[1].split(";").shift();
};

export const setAccessToken = token => {
  if (typeof document === "undefined") return;
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${ACCESS_TOKEN_COOKIE}=${token}; Max-Age=${TOKEN_MAX_AGE_SECONDS}; Path=/${secure}`;
};

export const clearAccessToken = () => {
  if (typeof document === "undefined") return;
  document.cookie = `${ACCESS_TOKEN_COOKIE}=; Max-Age=0; Path=/`;
};

export const decodeJwtPayload = token => {
  try {
    const part = token.split(".")[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch (e) {
    return null;
  }
};

// The server treats an invalid Bearer token as unauthenticated with NO session
// fallback, so callers must never attach a token that fails this check.
export const isTokenExpired = token => {
  const payload = decodeJwtPayload(token);
  const exp = payload && payload.exp;
  return !exp || exp * 1000 <= Date.now();
};

export const tokenNeedsRenewal = token => {
  const payload = decodeJwtPayload(token);
  const exp = payload && payload.exp;
  if (!exp) return false;
  const secondsLeft = exp - Date.now() / 1000;
  return secondsLeft > 0 && secondsLeft < RENEW_THRESHOLD_SECONDS;
};
